<template>
  <div
    class="md-layout md-gutter md-size-100 margin-top-40 md-alignment-center-center justify-content-center"
  >
    <md-progress-spinner
      :md-diameter="100"
      :md-stroke="10"
      md-mode="indeterminate"
    />
  </div>
</template>

<script>
import localDataFunctions from "@/localDataFunctions";

export default {
  name: "Midleware",
  mixins: [localDataFunctions],
  components: {},
  props: {},
  data() {
    return {};
  },

  created() {
    this.init();
  },
  methods: {
    init() {
      const token = this.getFromLocal("token");
      const tokenExpiration = this.getFromLocal("tokenExpiration");

      if (!token || !tokenExpiration) {
        this.$router.push("/login");
      } else {
        const dateNow = new Date();
        const expirationDate = new Date(tokenExpiration);

        if (expirationDate <= dateNow) this.$router.push("/login");
        else this.$router.push("/applications");
      }
    },
  },
};
</script>

<style></style>
